import styled from "styled-components";
import color from "../../utils/color";

export default styled.div`
  color: ${color.red};
  font-size: 13px;
`;
